// @flow
import React from 'react';
import i18n from 'app/common/lib/i18n';
import { Button } from 'gestalt';

type Props = {|
  color?: 'red' | 'gray',
  onClick: () => void,
  overrideText?: string,
|};

export default function AcknowledgeButton({ color, onClick, overrideText }: Props) {
  const buttonText =
    overrideText || i18n._('Got it', 'Acknowledge protected account modal message');
  return (
    <Button
      accessibilityLabel={buttonText}
      color={color || 'gray'}
      onClick={onClick}
      text={buttonText}
    />
  );
}
